export const MuiInputBase = {
  styleOverrides: {
    root: {
      backgroundColor: '#F1F1F1',
      color: '#5C5C5C',
    },
  },
}
